import {makeStyles, Theme} from '@material-ui/core/styles'
import {Colors} from 'components/common/useBaseStyle'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    '& > .MuiDialog-container > .MuiPaper-root': {
      [theme.breakpoints.up('xs')]: {
        minWidth: 354,
      },
      [theme.breakpoints.up('sm')]: {
        minWidth: 589,
      },
      [theme.breakpoints.up('md')]: {
        minWidth: 985,
      },
    },
    '& .MuiDialog-paperScrollPaper': {},
  },
  headerDialog: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  productName: {
    fontSize: '18px',
    fontWeight: 'bold',
  },
  contentWrap: {
    padding: '20px 45px',
  },
  table: {
    position: 'relative',
    minWidth: 880,
    color: 'red',
    marginTop: '15px',
    '& td': {
      color: Colors.text.content,
      fontSize: '0.8125rem',
      lineHeight: 2,
      paddingTop: 6,
      paddingBottom: 6,
      height: 43,
    },
    marginBottom: 20,
  },
  tableHeader: {
    height: 42,
    backgroundColor: Colors.tableHeaderBackground,
    verticalAlign: 'middle',
    borderRadius: 10,
    '& th': {
      color: Colors.text.content,
      fontSize: '0.8125rem',
      lineHeight: '1rem',
      fontWeight: 'bold',
    },
  },
  headerMax: {
    border: '1px solid rgba(224, 224, 224, 1)',
    padding: 8,
  },
  userGuide: {
    marginBottom: '15px',
    color: '#55b1c0',
    fontSize: '18px',
    width: '100%',
    backgroundColor: '#f3f6fb',
    padding: '6px 8px',
    textAlign: 'center',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
  },
  closeIcon: {
    width: 20,
    height: 20,
    color: '#c5c5c5',
  },
  closeButton: {
    backgroundColor: '#f4f4f4',
    width: 20,
    height: 20,
  },
  closeButtonWrap: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: '15px',
    marginTop: '10px',
  },
  productInfo: {
    flex: 1,
  },
  productTitle: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#333',
    maxWidth: '80%',
  },
  productType: {
    color: '#666',
    fontSize: '18px',
  },
  price: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#0cc7c7',
    marginBottom: 15,
  },
  periodSection: {
    background: '#f8f9fa',
    padding: 15,
    borderRadius: 8,
    marginBottom: 25,
    borderLeft: ' 3px solid #0cc7c7',
  },
  periodText: {
    fontSize: 18,
    color: '#333',
    lineHeight: 1.6,
    marginBottom: 5,
  },
  periodHighlight: {
    color: '#0cc7c7',
    fontWeight: 'bold',
  },
  description: {
    wordBreak: 'break-word',
  },
  headerTitle: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  headerInput: {
    margin: '2px 8px',
    textAlign: 'right',
    padding: '0 5px',
    width: 170,
    flex: 1,
    border: '1px solid',
    height: 30,
    outline: 'none',
  },
  readTermsText: {
    fontWeight: 700,
  },
  purchaseButton: {
    width: 120,
    height: 48,
  },
  inputAmount: {
    border: '1px solid #dcdcdc',
    height: 40,
    borderRadius: 4,
    padding: '0 10px',
    outline: 'none',
  },
  clickableText: {
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'underline',
    },
  },
}))

export default useStyles
